import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomExceptionService } from '../errorHandlers/custom-exception.service';
import { User } from '../Models/User';
import { UserService } from '../Services/user.service';
declare var $: any;
import { v4 as SessionID } from 'uuid';
import { CommonUtilities } from 'src/assets/js/common-utilities';
// import { Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  sessionClearTimer: NodeJS.Timeout;
  appRoleList = [];
  appModuleList = [];
  appMarketCircleList = [];
  Role = [];
  RoleId:string;
  MarketCircle=[];
  Module = [];
  displayChat: boolean = false;
  username: string
  URL: any
  ScreenList: any
  menuMaster: MenuItem[];
  ModuleList: any
  RoleList: any
  hiddenMarket : boolean = true;

  _Signoffform: FormGroup
  _User: User
  idleState = 'Not started.';
  // timedOut = false;
  lastPing?: Date = null;
  SessionPopup: boolean = false;
  timedOut: boolean = false
  public Url = environment.LogOutUrl;
  showChat() {
    this.displayChat = true;
  }
  constructor(private utility: CommonUtilities, private router: Router, private fb: FormBuilder, private _UserService: UserService, private _CustomExceptionService: CustomExceptionService,
    public sanitizer: DomSanitizer, private route: ActivatedRoute, private idle: Idle, private keepalive: Keepalive) {
    idle.setIdle(1800);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(5);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.SessionPopup = false;
      this.idleState = 'No longer idle.'
    });
    idle.onTimeout.subscribe(() => {
      this.idleState = 'Your Session has been Expired. Please Login to Proceed Further';
      this.timedOut = true;
      this.SessionPopup = true;
      localStorage.setItem("Istimeout", "true");
      // this.OnLogout();
    });
    idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!';
      this.SessionPopup = false;
    });
    idle.onTimeoutWarning.subscribe((countdown) => {
      this.SessionPopup = true;
      this.idleState = 'You will time out in ' + countdown + ' seconds!'
    });

    // sets the ping interval to 15 seconds
    keepalive.interval(15);

    keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.reset();
  }
  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
    this.SessionPopup = false;
  }
  // OnLogout() {
  //   alert('Logout');
  //   // this.navigateU
  // }
  ngOnInit(): void {
    const queryString = window.location.search;
    // console.log("gopu", queryString);
    const urlParams = new URLSearchParams(queryString);
    sessionStorage["username"] = JSON.stringify(urlParams.get('username'));
    sessionStorage["role"] = JSON.stringify(urlParams.get('role'));
    // console.log("bharath", urlParams.get('username'), urlParams.get('role'));
    this.username = JSON.parse(sessionStorage["username"])

    // console.log("cho", sessionStorage["ModuleList"])
    this._Signoffform = this.fb.group({
      username: [],
      password: [],
      role: [],
      userReferenceId: [],
      sessionid: [],
    });

    // if(sessionStorage["username"] == undefined)
    // {

    // }
    // var Session = sessionStorage["SessionId"]
    if (sessionStorage["SessionId"] != undefined) {
      if(urlParams.get('approval') != null)
      {
        this._UserService.GetUserAccessRightsDetailsinMailLink(urlParams.get('approval'), _sessionid).subscribe((result) => {
          const resultJSON = JSON.parse(JSON.stringify(result));
          //alert(resultJSON.approvalStatus.approvalid)
          var Module = JSON.parse(sessionStorage["ModuleList"])
        var Role = JSON.parse(sessionStorage["RoleList"])
        this.username = JSON.parse(sessionStorage["username"])        
        this.appRoleList = Role 
        // console.log(12,this.appRoleList);
        this.RoleId = urlParams.get('role');
        if(this.RoleId == '7')
        {
          this.hiddenMarket = false;
        }
        if(urlParams.get('status') != null)
        {     
          window.location.href = "/vApproval?status="+urlParams.get('status')+"&approvalid="+resultJSON.approvalStatus.approvalid
        }
        else{
          window.location.href = "/vApproval?approvalid="+resultJSON.approvalStatus.approvalid
        }
        }, error => { this._CustomExceptionService.handleError(error); }
        );
        
      }
      else{
        var Module = JSON.parse(sessionStorage["ModuleList"])
        var Role = JSON.parse(sessionStorage["RoleList"])
        this.username = JSON.parse(sessionStorage["username"])
        // console.log("head", Role)
        // console.log("mod", Module)
        this.appRoleList = Role
        this.RoleId = urlParams.get('role');
        // console.log(13,this.appRoleList);
      }
      
      // this.appRoleList = [
      //   { Role: 'Admin' },
      //   { Role: 'Executive Director' },
      //   { Role: 'Accounts Manager' },
      //   { Role: 'Finance Head' }
      // ]
      // this.Role = this.appRoleList[0];
      this.appModuleList = Module

      this.Module = this.appModuleList[0];
      // console.log(11,this.appRoleList);
      this.RoleId = urlParams.get('role');
    }
    else {
      // debugger;
      // const queryString = window.location.search;
      // console.log("gopu", queryString);
      // const urlParams = new URLSearchParams(queryString);
      // sessionStorage["username"] = JSON.stringify(urlParams.get('username'));
      // sessionStorage["role"] = JSON.stringify(urlParams.get('role'));
      // console.log("gopu", urlParams.get('username'), urlParams.get('role'));
      // this.route.queryParams
      // .subscribe(params => {

      //   console.log("gopu",params); // { orderby: "price" }
      //   sessionStorage["username"] = JSON.stringify(params.username);
      //   sessionStorage["role"] = JSON.stringify(params.role);
      // });
      if(urlParams.get('approval') != null)
      {
        var _sessionid = SessionID();
        this._UserService.GetUserAccessRightsDetailsinMailLink(urlParams.get('approval'), _sessionid).subscribe((result) => {
          // console.log()
          
          const resultJSON = JSON.parse(JSON.stringify(result));
          if (sessionStorage["SessionId"] == undefined)
          {
            // console.log("user", resultJSON);
            sessionStorage["SessionId"] = resultJSON.loggedUser.sessionid;
            sessionStorage["username"] = JSON.stringify(resultJSON.loggedUser.username);
            sessionStorage["role"] = JSON.stringify(resultJSON.loggedUser.role);
            this.username = resultJSON.loggedUser.username;
            // console.log("nav", sessionStorage["SessionId"])
            this.ScreenList = resultJSON.lstUserScreens
            sessionStorage["ScreenList"] = JSON.stringify(this.ScreenList)
            // console.log(this.ScreenList)
            this.ModuleList = resultJSON.lstUserModules
            sessionStorage["ModuleList"] = JSON.stringify(this.ModuleList)
            // console.log("bh", JSON.parse(sessionStorage["ModuleList"]))
            this.RoleList = resultJSON.lstUserRoles
            sessionStorage["RoleList"] = JSON.stringify(this.RoleList)
            this.appRoleList = this.RoleList;
            this.appModuleList = this.ModuleList;
            this.menuMaster = this.ScreenList;
            //this.appMarketCircleList = resultJSON.lstMarketCircle
            // this.Role = this.appRoleList[0];
            this.RoleId = urlParams.get('role');

            this.Module = this.appModuleList[0];
            if(this.RoleId == '7')
            {
              this.hiddenMarket = false;
            }
            
          }
          else{
            var Module = JSON.parse(sessionStorage["ModuleList"])
            var Role = JSON.parse(sessionStorage["RoleList"])
            this.username = JSON.parse(sessionStorage["username"])
            this.appRoleList = Role
          }          
          //alert(resultJSON.approvalStatus.approvalid)
          if(urlParams.get('status') != null)
          {
            //window.location.href = "/vApproval?status="+urlParams.get('status')+"&approvalid="+resultJSON.approvalStatus.approvalid
            //window.location.href = window.location.origin + "/vApproval";
            this.router.navigate(['/vApproval']);
          }
          else{
            window.location.href = "/vApproval?approvalid="+resultJSON.approvalStatus.approvalid
          }

        }, error => { this._CustomExceptionService.handleError(error); }
        );

      }
      else{
        this._User = this._Signoffform.value
        this._User.username = JSON.parse(sessionStorage["username"])
        this._User.role = JSON.parse(sessionStorage["role"])
        var _sessionid = SessionID()
        // console.log(this._User)
        this._UserService.GetUserAccessRightsDetails(this._User, _sessionid).subscribe((result) => {
          const resultJSON = JSON.parse(JSON.stringify(result));
          // console.log("user", resultJSON);
          sessionStorage["SessionId"] = resultJSON.loggedUser.sessionid;
          //sessionStorage["username"] = JSON.stringify(resultJSON.loggedUser.username);
          //sessionStorage["role"] = JSON.stringify(resultJSON.loggedUser.role);
          // console.log("nav", sessionStorage["SessionId"])
          this.ScreenList = resultJSON.lstUserScreens
          sessionStorage["ScreenList"] = JSON.stringify(this.ScreenList)
          // console.log(this.ScreenList)
          this.ModuleList = resultJSON.lstUserModules
          sessionStorage["ModuleList"] = JSON.stringify(this.ModuleList)
          // console.log("bh", JSON.parse(sessionStorage["ModuleList"]))
          this.RoleList = resultJSON.lstUserRoles
          sessionStorage["RoleList"] = JSON.stringify(this.RoleList)
          this.appRoleList = this.RoleList;
          this.appModuleList = this.ModuleList;
          // this.Role = this.appRoleList[0];
          this.RoleId = urlParams.get('role');
          console.log(resultJSON);

          this.Module = this.appModuleList[0];
          this.appMarketCircleList = resultJSON.lstMarketCircle;
          this.MarketCircle = this.appMarketCircleList[0];
          if(this.RoleId == '7')
          {
            this.hiddenMarket = false;
          }

        }, error => { this._CustomExceptionService.handleError(error); }
        );
      }
    }
  }
  changeRole() {

  }
  onBeforeUnload(){
    //debugger;
    // this.OnLogout()
    // alert("ok")
  }
  SessionWatcher() {
    if (!this.sessionClearTimer) {
      this.sessionClearTimer = setInterval(() => {
        if (!sessionStorage['SessionId']) {
          this.OnLogout();
        }
      }, 1000);
    }
  }

  // CloseWindow(){
  //   window.open('','_parent','');
  //   window.close();
  //   }
  OnLogout() {
    $(".karthikdev").on("click", function(){
      // alert('hi2');
      //window.close();
      
  });
    this._User = this._Signoffform.value
    this._User.username = JSON.parse(sessionStorage["username"])
    this._User.role = JSON.parse(sessionStorage["role"])
    this._User.sessionid = sessionStorage["SessionId"]

    this._UserService.Logout(this._User).subscribe((result) => {
      const resultJSON = JSON.parse(JSON.stringify(result));
      if (resultJSON.tranStatus.result == true && (resultJSON != null || resultJSON != undefined)) {
        // console.log(resultJSON)
        sessionStorage.clear();
        this.utility.ClearTimer();
        clearInterval(this.sessionClearTimer);
        window.location.href = this.Url
      }
      else {
        this._CustomExceptionService.handleError(resultJSON.tranStatus.lstErrorItem[0].message);
      }
    }, error => { this._CustomExceptionService.handleError(error) })
    // window.open('', '_parent', '').close();
    window.location.href = this.Url;
  }
  
  // this._UserService.logout().subscribe((result) => {
  //   sessionStorage.clear();
  //   this.EnableMenus.emit(false);
  //   this.utility.ClearTimer();
  // this.URL = this.sanitizer.bypassSecurityTrustResourceUrl("/https://anchor.ponpurelogistics.com/");
  //this.router.navigate(['/https://anchor.ponpurelogistics.com/']);
  //this.router.navigate([this.sanitizer.bypassSecurityTrustResourceUrl("/https://anchor.ponpurelogistics.com/")]);
  // clearInterval(this.sessionClearTimer);

  // });
  popupClose() {
    localStorage.setItem("Istimeout", "false");
    this.SessionPopup = false;
  }
  // onHide(){
  //   this.OnLogout();
  // }
}
